import React, { useState, useEffect } from "react";
import "./Orders.css";
import Nav from "../../components/nav/nav";
import Footer from "../../components/footer/Footer";
import LoginPopup from "../../components/Login/loginPopup";
import { useNavigate } from "react-router-dom";
const BASE_URL = "https://api.aizoteq.com:3000";

const OrderHistory = () => {
    const [showLogin, setShowLogin] = useState(false);
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const isLoggedIn = !!localStorage.getItem("idToken");
    const handleReorder = (order) => {
        const items = order.items.map(item => ({
            id: item.id || item.product_id, // ensure product id exists
            name: item.name,
            price: item.price,
            quantity: item.qty
        }));

        navigate("/checkout", {
            state: {
                selectedItems: items,
                fromCart: true // 🔥 important (for your previous issue fix)
            }
        });
    };
    useEffect(() => {
        if (!isLoggedIn) {
            setLoading(false);
            return;
        }

        const fetchOrders = async () => {
            try {
                const res = await fetch(
                    "https://host.aizoplug.com:3000/ecommerce/order/my",
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("idToken")}`,
                        },
                    }
                );

                const data = await res.json();
                console.log("Raw Orders Data:", data);

                // 🔥 Transform API → UI format
                const formatted = data.map((o) => ({
                    id: o.order.id,
                    date: new Date(o.order.created_at).toLocaleDateString(),
                    total: o.order.total,
                    status: o.order.order_status,
                    items: o.items.map((item) => ({
                        name: item.product_name,
                        qty: item.quantity,
                        price: item.price,
                        image:
                            item.images && item.images.length > 0
                                ? BASE_URL + item.images[0]  // ✅ prepend base URL
                                : "/placeholder.png",
                    })),
                }));

                setOrders(formatted);
            } catch (err) {
                console.error("Error fetching orders:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [isLoggedIn]);

    return (
        <div className="order-page-wrapper">
            <Nav />

            <div className="order-page">
                <div className="order-header">
                    <h1 className="order-title">Order History</h1>
                    <p className="order-subtitle">{orders.length} orders found</p>
                </div>

                {!isLoggedIn ? (
                    <div className="login-required">
                        <h2>Please Login to View Orders</h2>
                        <p>You need to login to access your order history</p>

                        <button
                            className="login-btn"
                            onClick={() => setShowLogin(true)}
                        >
                            Login
                        </button>
                    </div>
                ) : loading ? (
                    <div className="order-empty">
                        <h2>Loading...</h2>
                    </div>
                ) : orders.length === 0 ? (
                    <div className="order-empty">
                        <h2>No Orders Yet</h2>
                        <p>You haven’t placed any orders</p>
                    </div>
                ) : (
                    <div className="order-list">
                        {orders.map((order) => (
                            <div className="order-card" key={order.id}>

                                {/* Top Section */}
                                <div className="order-top">
                                    <div>
                                        <h3>Order #{order.id}</h3>
                                        <p>{order.date}</p>
                                    </div>

                                    <div className={`order-status ${order.status.toLowerCase()}`}>
                                        {order.status}
                                    </div>
                                </div>

                                {/* Items */}
                                <div className="order-items">
                                    {order.items.map((item, index) => (
                                        <div className="order-item" key={index}>
                                            <img src={item.image} alt={item.name} />
                                            <div>
                                                <h4>{item.name}</h4>
                                                <p>Qty: {item.qty}</p>
                                            </div>
                                            <span>₹{item.price}</span>
                                        </div>
                                    ))}
                                </div>

                                {/* Bottom */}
                                <div className="order-bottom">
                                    <h3>Total: ₹{order.total}</h3>

                                    <div className="order-actions">
                                        {/* <button className="view-btn">View Details</button> */}
                                        <button
                                            className="reorder-btn"
                                            onClick={() => handleReorder(order)}
                                        >
                                            Reorder
                                        </button>
                                    </div>
                                </div>

                            </div>
                        ))}
                    </div>
                )}
            </div>

            <LoginPopup
                show={showLogin}
                onClose={() => setShowLogin(false)}
            />

            <Footer />
        </div>
    );
};

export default OrderHistory;